// Header nav / footer / language switch
export default {
  brand: {
    name: 'IEasyTool',
    slogan: 'Make work easier'
  },
  nav: {
    home: 'Home',
    favorites: 'Favorites',
    category: 'Categories'
  },
  footer: {
    home: 'Home',
    contact: 'Contact Us',
    terms: 'Terms',
    privacy: 'Privacy',
    partners: 'Partners',
    disclaimer: 'Tools on this site are for learning and exchange only; any illegal use is strictly prohibited.'
  },
  lang: {
    zh: '中文',
    en: 'English',
    switch: 'Language'
  },
  ad: {
    promo: 'Ad',
    recommend: 'Featured'
  }
}
